import { PspContext } from "@/config/contexts";
import { useContext } from "react";

export function useMfaInitial() {
  const { lang } = useContext(PspContext);
  return { lang };
}
